import React from "react";
import PdfListPage from "./PdfListPage";
import { useBul } from "./BulLayout";

export default function Admissions() {
  const data = useBul();
  return (
    <PdfListPage
      eyebrow="Join Us"
      title="Admission Notices"
      accent="coral"
      items={data.notices_admission || []}
      testid="bul-admissions"
      emptyMsg="Admission notices will appear here once published."
    />
  );
}
